/**
 * functionUrl — the one place that builds an HTTP Cloud Function's address.
 *
 * Every browser call to an HTTP function goes through this, so a build
 * always talks to its own project's functions: `VITE_FIREBASE_FUNCTIONS_URL`
 * comes from `.env.uat` (mntnd-app) or `.env.production` (mntnd-prod).
 * Before PB-04 (2026-10-23) invitation acceptance, the push test and the
 * Dev Tools pending-user fix had the UAT address typed in, so a prod build
 * would have called UAT's functions and UAT's database.
 */
const ALLOWED_BASES = [
  'https://us-central1-mntnd-app.cloudfunctions.net',
  'https://us-central1-mntnd-prod.cloudfunctions.net',
]

export function functionsBaseUrl(): string {
  const base = (import.meta.env.VITE_FIREBASE_FUNCTIONS_URL || '').replace(
    /\/$/,
    ''
  )
  if (!ALLOWED_BASES.includes(base)) {
    throw new Error(
      `functionsBaseUrl(): VITE_FIREBASE_FUNCTIONS_URL "${base}" is not one of the known projects`
    )
  }
  return base
}

export function functionUrl(name: string): string {
  return `${functionsBaseUrl()}/${name}`
}
